import React from 'react';
import { Box, useTheme, useMediaQuery, Typography, Card, CardMedia } from '@mui/material';
import { styled } from '@mui/material/styles';
import AccordionCustom from '../components/accordion';

// const Img = styled('img')({
//   margin: 'auto',
//   display: 'block',
//   maxWidth: '100%',
//   maxHeight: '100%',
// });

const ACCORDION_SET = [
  {
    summary: "Excel好难, 跟其他老师都学不会, 怎么办?",
    detail: `
      Excel其实不难, 掌握方法后超级简单! 跟我3天就能轻松上手, 成为Excel达人~😘
    `
  },
  {
    summary: "学习时可以提问吗？",
    detail: `当然可以! 课程有专门线上咨询, 老师会耐心详细解答你的问题, 让学习之路更加顺畅哦!🤓`
  },
  {
    summary: "课程适合哪些人呢?",
    detail: " 本课程适合办公人士、学生及求职者, 即使是零基础的小白也能快速上手哦! 🌟"
    },
  {
    summary: "需要提前学会Excel吗?",
    detail:  "不需要! 课程从基础讲起, 适合完全没有经验的用户, 轻松入门!📚😊"
   },
  {
    summary: "学习后能获得哪些技能?",
    detail:  "你将掌握表格制作、数据分析、函数运用等技能, 成为Excel高手, 职场表现更出色!📊💪"
  },
]

const ResponsiveLayout = () => {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.up('sm')); // sm及以上返回true
  const Img = styled('img')({
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
  });

  return (
    <Box
      sx={{
        width: '100%',
        height: isSm ? 'auto' : '80%', // 外层高度自适应
        p: 2,
        boxSizing: 'border-box',
        backgroundColor: "#EFDDD0"
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: isSm ? 'row' : 'column', // sm及以上时row(左右)，xs时column(上下)
          height: isSm ? '100vh' : '150vh' // sm及以上固定高度，xs自适应
        }}
      >
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            flexDirection: 'column',
            minHeight: isSm ? 'auto' : '150px', // xs时给个最小高度
            width: isSm ? '10%' : 'auto'
          }}
        >
          {/* <Img alt="Picture" src="https://images.pexels.com/photos/7222979/pexels-photo-7222979.jpeg"></Img> */}
          <Box sx={{ maxWidth: 800, position: 'relative' }}>
            {/* 视频容器 */}
            <Box
              sx={{
                position: 'relative',
                zIndex: 1,
                display: 'flex',
                flexDirection: 'column', // 明确设置为垂直排列
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Box component="div" sx={{
                    backgroundColor: "black",
                    width: "100%",
                    height: {sm: "35px", xs: "20px"},
                    borderTopLeftRadius: "120px",
                    borderTopRightRadius: "120px"}} />
              <CardMedia
                component="video"
                image="/assets/brief_layout_video-1.mp4"
                autoPlay
                loop
                muted
                playsInline  // 在iOS上需要这个属性
                sx={{
                  width: 'auto',
                  height: {sm: '508px', xs: '400px'},
                  // display: 'block',
                  // 现代浏览器可以使用这个简单的方式来隐藏控制条
                  '& .MuiCardMedia-media': {
                    '--controls-display': 'none'
                  }
                }}
              />
              <Box component="div" sx={{
                    backgroundColor: "black",
                    width: "100%",
                    height: {sm: "60px", xs: "40px"},
                    borderBottomLeftRadius: "120px",
                    borderBottomRightRadius: "120px"}} />
            </Box>
            {/* iPhone 框层 */}
            <Box
              component="img"
              src="/assets/apple-iphone-15-pink-portrait.png"
              alt="iPhone Frame"
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                zIndex: 2,
                width: 'auto',
                height: {sm: '640px', xs: '500px'},
                pointerEvents: 'none', // 避免干扰视频点击
              }}
            />
          </Box>
        </Box>
        <Box
          sx={{
            flex: 1,
            display: 'flex',
            // alignItems: 'center',
            justifyContent: 'flex-start',
            flexDirection: 'column',
            minHeight: isSm ? 'auto' : '400px', // xs时给个最小高度
            // borderLeft: isSm ? '3px solid #EF7F95' : '0px',
            paddingLeft: isSm ? '20px' : '0px'
          }}
        >
          <Typography variant="h4" mb={8} sx={{fontWeight: 'bold', color: '#292a2d'}}>
            常见问题 (FAQ)
          </Typography>
          <AccordionCustom accordionSet={ACCORDION_SET}></AccordionCustom>
        </Box>
      </Box>
    </Box>
  );
};

export default ResponsiveLayout;